<template>
  <div
    :id="name"
    class="row push-up"
  >
    <div class="small-12 columns">
      <base-file-field-attached-files
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        :title="title"
        :no-files-label="noFilesLabel"
        :remove-file-label="removeFileLabel"
      />
    </div>
    <div class="small-12 medium-4 large-6 columns">
      <base-file-field-input
        :id="id"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        class="push-up"
        :required="required"
        :button-class="buttonClass"
        :data-vv-as="dataVvAs"
        :add-file-label="addFileLabel"
        :error-modal-title="errorModalTitle"
        :error-modal-filetypes-link-url="errorModalFiletypesLinkUrl"
        :error-modal-filetypes-link-text="errorModalFiletypesLinkText"
        :error-modal-button-label="errorModalButtonLabel"
        :allowed-file-types="allowedFileTypes"
        :show-in-photo-mode="showInPhotoMode"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFileField',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    name: {
      type: String,
      default() {
        return 'base-file-field';
      }
    },
    title: {
      type: String,
      default: 'Filer:'
    },
    addFileLabel: {
      type: String,
      default: 'Vælg fil'
    },
    dataVvAs: {
      type: String,
      default: 'Vedhæftet fil'
    },
    required: {
      type: Boolean,
      default: true
    },
    buttonClass: {
      type: String,
      default: ''
    },
    removeFileLabel: {
      type: String,
      default: 'Slet fil'
    },
    noFilesLabel: {
      type: String,
      default: 'Ingen filer er tilføjet'
    },
    errorModalTitle: {
      type: String,
      default: 'Vi modtager desværre ikke den valgte filtype'
    },
    errorModalFiletypesLinkUrl: {
      type: String,
      default: null
    },
    errorModalFiletypesLinkText: {
      type: String,
      default: null
    },
    errorModalButtonLabel: {
      type: String,
      default: 'Tilbage til skaden'
    },
    id: {
      type: String,
      default: 'files'
    },
    allowedFileTypes: {
        type: Array,
        default() {
            return null;
        }
    },
    showInPhotoMode: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.button {
  line-height: rem-calc(40);
}
</style>
